export type ContactPayload = {
  name: string;
  email: string;
  topic: string;
  orderNumber?: string;
  message: string;
  website?: string;
  turnstileToken?: string;
  page?: string;
};

export type ContactResult = {
  ok: boolean;
  message: string;
  setupRequired?: boolean;
};

export async function submitContact(payload: ContactPayload): Promise<ContactResult> {
  const response = await fetch('/api/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  let result: ContactResult;
  try {
    result = (await response.json()) as ContactResult;
  } catch {
    result = { ok: false, message: 'The support request could not be sent.' };
  }

  if (!response.ok) return { ...result, ok: false };
  return result;
}
